import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [];

  async doFetch(url, method, body, headers = false) {
    if (!headers) {
      headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
        authenticity_token: this.getCsrfToken(),
      };
    }
    const response = await fetch(url, {
      method: method,
      headers: headers,
      body: body,
    });
    return response;
  }

  flash(message, status) {
    const event = document.createEvent("Event");
    event.initEvent("flashMessage");
    event.detail = { message: message, status: status };
    event.initEvent("flashMessage");
    document.dispatchEvent(event);
  }

  getCsrfToken() {
    if (
      document.querySelector('meta[name="csrf-token"]') &&
      document.querySelector('meta[name="csrf-token"]').content
    ) {
      return document.querySelector('meta[name="csrf-token"]').content;
    }
    console.log("no csrf-token found in document!");
    return "";
  }

  fadeOut(element, duration = 20) {
    if (element == undefined) {
      return false;
    }
    var op = 1;
    clearInterval(self.timer);
    self.timer = setInterval(function () {
      if (op <= 0.1) {
        clearInterval(self.timer);
        element.style.display = "none";
      }
      element.style.opacity = op;
      element.style.filter = "alpha(opacity=" + op * 100 + ")";
      op -= op * 0.1;
    }, duration);
  }

  fadeIn(element, duration = 20) {
    if (element == undefined) {
      return false;
    }
    var op = 0;
    clearInterval(self.timer);
    element.style.display = "block";
    self.timer = setInterval(function () {
      if (op >= 1) {
        clearInterval(self.timer);
      }
      element.style.opacity = op;
      element.style.filter = "alpha(opacity=" + op * 100 + ")";
      op += 0.1;
    }, duration);
  }
}
